import React from 'react';
import ReactPlayer from 'react-player/youtube';
import { PlayCircle, Lightbulb, Heart, Target } from 'lucide-react';
export const VisionStory = () => {
  const visionPoints = [{
    icon: <Lightbulb className="w-6 h-6" data-id="element-431" />,
    title: 'Innovation in Education',
    description: 'Reimagining how technology can support meaningful coaching relationships',
    gradient: 'from-primary-500 to-blue-600'
  }, {
    icon: <Heart className="w-6 h-6" data-id="element-432" />,
    title: 'Human-Centered Design',
    description: 'Built with and for instructional coaches to enhance their impact',
    gradient: 'from-blue-600 to-purple-600'
  }, {
    icon: <Target className="w-6 h-6" data-id="element-433" />,
    title: 'Measurable Impact',
    description: 'Focused on improving teacher support and student outcomes',
    gradient: 'from-pink-600 to-orange-600'
  }];
  return <section id="vision-story" className="w-full py-section-mobile md:py-section-desktop bg-white relative overflow-hidden" data-id="element-434">
      <div className="container mx-auto px-6" data-id="element-435">
        <div className="max-w-5xl mx-auto" data-id="element-436">
          {/* Header Section */}
          <div className="text-center mb-20 opacity-100" data-id="element-437">
            <h2 className="text-h2-mobile md:text-h2-desktop font-serif font-normal text-teal-900 mb-4 leading-tight" data-id="element-438">
              Our mission for high-quality coaching at scale
            </h2>
            <p className="text-xl text-teal-800 max-w-3xl mx-auto" data-id="element-439">
              Our vision is to extend the reach of great instructional coaches,
              making their expertise and support more accessible to every
              teacher.
            </p>
          </div>
          {/* Vision Points */}
          {/* Video Section */}
          <div className="relative lg:max-w-[80%] lg:mx-auto" data-id="element-440">
            <div className="absolute inset-0 bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl opacity-90" data-id="element-441" />
            <div className="relative rounded-2xl overflow-hidden shadow-xl border border-gray-800" data-id="element-442">
              <ReactPlayer url="https://www.youtube.com/watch?v=JAwX1PJzNJU" width="100%" height="100%" controls playing={false} light={true} playIcon={<div className="w-20 h-20 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center border-2 border-white/20 transition-transform hover:scale-110 duration-300" data-id="element-444">
                    <PlayCircle className="w-12 h-12 text-white" data-id="element-445" />
                  </div>} className="aspect-video" data-id="element-443" />
            </div>
          </div>
          {/* Bottom Content */}
          <div className="mt-12 text-center lg:max-w-[80%] lg:mx-auto" data-id="element-446">
            <div className="space-y-6 max-w-lg mx-auto" data-id="element-447">
              <p className="text-xl text-teal-800" data-id="element-448">
                In this short talk at{' '}
                <span className="font-medium" data-id="element-449">The AI Show at ASU+GSV 2025</span>
                , learn how Nisa aims to transform instructional coaching.
              </p>
              <p className="text-gray-600" data-id="element-450">
                From overloaded teachers to the promise of "AI as connective
                tissue," this vision grounds every decision we make.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};